import fileDownload from 'js-file-download';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3203/crear'
  : 'https://sideop-excel.hermosillo.gob.mx/crear';

const BASE_URL_MULTI = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3203/multi'
  : 'https://sideop-excel.hermosillo.gob.mx/multi';

const obtenerMensajeError = (err) => (
  (err.response && err.response.data && err.response.data.message) || err.message
);

export default {
  methods: {
    async mixGenerarExcel(data) {
      this.estaCargando = true;
      try {
        const res = await this.axios.post(
          BASE_URL,
          data,
          { responseType: 'blob' },
        );
        fileDownload(res.data, `${this.contrato?.numero ? this.contrato.numero : ''}${this.contrato?.numero ? '_' : ''}${this.nombreDocumento}.xlsx`);
      } catch (err) {
        this.mixMensajeError(obtenerMensajeError(err));
      } finally {
        this.estaCargando = false;
      }
    },
    async mixGenerarExcelMultiPagina(data) {
      this.estaCargando = true;
      try {
        const res = await this.axios.post(
          BASE_URL_MULTI,
          data,
          { responseType: 'blob' },
        );
        fileDownload(res.data, `${this.contrato?.numero ? this.contrato.numero : ''}${this.contrato?.numero ? '_' : ''}${this.nombreDocumento}.xlsx`);
      } catch (err) {
        this.mixMensajeError(obtenerMensajeError(err));
      } finally {
        this.estaCargando = false;
      }
    },
  },
};
